import { Basic } from "./Basic"
import { Landing } from "./Landing"
import { ResourcesListing } from "./ResourcesListing"
import { CaseStudiesListing } from "./CaseStudiesListing"

const entryTypes = {
  Basic,
  Landing,
  ResourcesListing,
  CaseStudiesListing,
}

export const PageEntry = ({ entry }) => {
  const EntryType = entryTypes[entry.typeHandle] || null

  return <EntryType entry={entry} />
}
